import { Navigate, useParams } from 'react-router-dom'

import { useGetByTenantNoteQuery } from '@/api/rtk-api'
import { MasterDetail } from '@/components/core-v2'
import { PATH, TENANT } from '@/const'

import { NotesDetail } from '../../components/notes-detail'
import { NotesDetailEmptyState } from '../../components/notes-detail/empty-state'
import { NotesMaster } from '../../components/notes-master'
import { ReportingTemplate } from '../../templates/top-level-tab-template'
import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'
import { Loading } from './loading'

const Body = () => {
  const { isFetching, isLoading: isDashboardLoading } =
    useFilteredGetByTenantAccountDashboardQuery()

  const { data: notes, isLoading: isNotesLoading } = useGetByTenantNoteQuery({
    tenant: TENANT
  })

  const { noteId } = useParams()

  const isLoading = isDashboardLoading || isNotesLoading || isFetching

  if (isLoading) return <Loading />

  const selectedNote = !noteId ? null : notes.find(note => note.noteId === noteId)

  if (noteId && !selectedNote) {
    return <Navigate to={PATH.reportsNotes} />
  }

  return (
    <MasterDetail
      detailChildren={noteId ? <NotesDetail note={selectedNote} /> : <NotesDetailEmptyState />}
      masterChildren={<NotesMaster />}
    />
  )
}

export const ReportingNotes = () => (
  <ReportingTemplate
    backgroundColor="grey"
    tabValue="notes"
    withOverflow={false}
    withPadding={false}
  >
    <Body />
  </ReportingTemplate>
)
